<script>
import Loading from '../Loading/Loading.vue';
import Alert from '../Alert/Alert.vue';
import ManageAllocationList from '../ManageAllocationList/ManageAllocationList.vue';
import ManageAllocationForm from '../ManageAllocationForm/ManageAllocationForm.vue';
import ManageAllocationFilters from '../ManageAllocationFilters/ManageAllocationFilters.vue';
import ManageAllocationCalendar from '../ManageAllocationCalendar/ManageAllocationCalendar.vue';
import ManageAllocationModal from '../ManageAllocationModal/ManageAllocationModal.vue';
import ManageAllocationCalendarInfoBox from '../ManageAllocationCalendarInfobox/ManageAllocationCalendarInfobox.vue';
import ManageAllocationRequest from '../ManageAllocationRequest/ManageAllocationRequest.vue';
import InfoWidget from '../InfoWidget/InfoWidget.vue';
import {mapActions, mapState} from 'vuex';
import store from '../../store';

export default {
    components: {
        Loading,
        ManageAllocationList,
        ManageAllocationForm,
        ManageAllocationFilters,
        ManageAllocationCalendar,
        ManageAllocationModal,
        ManageAllocationRequest,
        ManageAllocationCalendarInfoBox,
        InfoWidget,
        Alert
    },
    computed: {
        ...mapState({
            tips: state => state.allocation.manageAllocationPage.tips,
            requestMessage: state => state.allocation.request.message,
            error: state => state.allocation.data.error,
            loading: state => state.allocation.data.loading,
            timer: state => state.allocation.timer,
            routeParams: state => state.route.params,
            supplier: state => state.auth.supplier,
            sites: state => state.allocation.form.filters.sites
        })
    },
    created () {
        const siteId = this.routeParams.siteId;
        const accommodationSiteId = this.routeParams.accommodationSiteId;
        this.getRouteFilters(accommodationSiteId).then(() => {
            this.setRouteFilters({
                siteId,
                accommodationSiteId
            })
        });
        this.fetchManageAllocationData(accommodationSiteId);
    },
    methods: {
        ...mapActions({
            countdown: 'allocation/countdown',
            resetState: 'allocation/resetState',
            getRouteFilters: 'allocation/getRouteFilters',
            setRouteFilters: 'allocation/setRouteFilters',
            setAccommodation: 'allocation/setAccommodation',
            setCalendarDates: 'allocation/setCalendarDates',
            setSelectedRouteFilters: 'allocation/setSelectedRouteFilters',
            fetchManageAllocationData: 'allocation/fetchManageAllocationData',
            updateProductAndSupplier: 'nav/updateProductAndSupplier'
        })
    },
    beforeRouteUpdate(to, from, next) {
        const params = to.params;
        store.dispatch('allocation/getRouteFilters', params.accommodationSiteId).then(() => {
            store.dispatch('allocation/setRouteFilters', {
                siteId: params.siteId,
                accommodationSiteId: params.accommodationSiteId
            })
        });
        store.dispatch('allocation/fetchManageAllocationData', params.accommodationSiteId);
        next();
    },
    beforeRouteLeave (to, from, next) {
        Promise.all([
            this.$refs.infoWidget.clean()
        ]).then(() => {
            next();
        });
    }
}
</script>
<template>
    <div class="manage-allocation-page">
        <div v-if="error && !loading" class="manage-allocation-page__error">
            <i class="fa fa-exclamation-circle"/>
            <div class="manage-allocation-page__error-message">{{ $t('manageAllocationPage.error') }}</div>
        </div>
        <info-widget ref="infoWidget" :tips="tips"/>
        <div v-if="!error" class="manage-allocation-page__content">
            <manage-allocation-modal/>
            <manage-allocation-request/>
            <manage-allocation-filters/>
            <manage-allocation-calendar-info-box/>
            <manage-allocation-calendar/>
            <manage-allocation-list/>
            <alert :translation-prefix="'manageAllocationPage'"/>
        </div>
        <div class="manage-allocation-page__mobile">
            <div class="manage-allocation-page__mobile-content">
                <i class="fa fa-fw fa-exclamation-triangle"/>
                {{ $t('manageAllocationPage.mobile') }}
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ManageAllocationPage/ManageAllocationPage.vue